export default "__VITE_ASSET__d8b10a21__"